// marketo-form-clear.js
// Clear js that marketo inserts

const $body = $(document.body);
if ($body.hasClass("page--document")) {
  MktoForms2.whenReady(function(form) {
    (function() {

      var reset;

      reset = function() {
        var
        _target = [ 'mktoHasWidth', 'mktoFormCol', 'mktoOffset' ],
        target = []
        ;

        for ( var i=0; i<_target.length; i++ ) {
          _target[i] = [].slice.call( document.getElementsByClassName( _target[i] ) );
          target = target.concat( _target[i] );
        }

        for ( var x=0; x<target.length; x++ ) {
          target[x].setAttribute( 'style', '' );
        }
      };

      reset();
      window.addEventListener( 'resize', reset );

    }());
  });
}
